// A small history router for the site's pages (no library): the path as state, navigate() pushes, back/forward follow.
import { useEffect, useState } from 'react';

const listeners = new Set<() => void>();

export function navigate(to: string, replace = false) {
  if (to === location.pathname + location.search) return;
  if (replace) history.replaceState(null, '', to);
  else history.pushState(null, '', to);
  for (const l of listeners) l();
}

export function useLocation() {
  const [loc, setLoc] = useState({ path: location.pathname, search: location.search });
  useEffect(() => {
    const on = () => setLoc({ path: location.pathname, search: location.search });
    listeners.add(on);
    addEventListener('popstate', on);
    return () => {
      listeners.delete(on);
      removeEventListener('popstate', on);
    };
  }, []);
  return loc;
}

/** an <a> that routes inside the site */
export function linkProps(to: string) {
  return {
    href: to,
    onClick: (e: React.MouseEvent) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      navigate(to);
    },
  };
}
